<template>
  <van-tag v-if="labels" mark :style="labels_color">{{ labels_text }}</van-tag>
</template>

<script>
    export default {
      name: "labels-tag",
      props: {
        labels_color:'',
        labels_text:'',
        labels:'',
      },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/labels-tag.vue